/**
 * MedCaddy API Client - Providers Module
 * Handles healthcare providers CRUD.
 */

import { apiFetch, assertOk, assertOkWithDetail } from './core';

// Providers API
export const providers = {
  async list() {
    const response = await apiFetch('/providers');
    assertOk(response, 'Failed to fetch providers');
    return response.json();
  },

  async create(provider) {
    const response = await apiFetch('/providers', {
      method: 'POST',
      body: JSON.stringify(provider)
    });
    await assertOkWithDetail(response, 'Failed to create provider');
    return response.json();
  },

  async update(id, provider) {
    const response = await apiFetch(`/providers/${id}`, {
      method: 'PUT',
      body: JSON.stringify(provider)
    });
    await assertOkWithDetail(response, 'Failed to update provider');
    return response.json();
  },

  async remove(id) {
    const response = await apiFetch(`/providers/${id}`, {
      method: 'DELETE'
    });
    assertOk(response, 'Failed to delete provider');
  }
};
